<div
  class="container-fluid tw-relative tw-bg-black tw-pb-12 tw-overflow-hidden tw-h-[100dvh]"
>
  <div
    class="tw-absolute tw-inset-0 tw-bg-no-repeat tw-bg-left-bottom tw-bg-[url('/assets/images/ISOLOGO.png')] tw-opacity-60 tw-blur-xs tw-z-0 tw-pointer-events-none custom-bg-size tw-hidden md:tw-block"
    style="background-position: bottom left"
  ></div>

  <div
    class="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-center tw-w-[90%] sm:tw-w-[80%] tw-mx-auto tw-h-[95%] tw-gap-8 md:tw-gap-0 tw-relative"
  >
    <div class="tw-flex-col sm:tw-mt-3">
      <h2
        class="tw-text-5xl md:tw-text-7xl tw-font-montserrat tw-font-bold tw-text-white tw-text-center"
      >
        {{title}}
      </h2>
      <div
        class="tw-h-1 tw-bg-gradient-to-r tw-from-transparent tw-via-[#0000FF] tw-to-[#F67011] tw-w-3/4 tw-mx-auto tw-my-4"
      ></div>
    </div>

    <!-- Imagen a la derecha con sombra azul-naranja -->
    <div
      class="tw-px-2 tw-order-1 md:tw-order-2 relative tw-mt-8 md:tw-mt-0 tw-flex tw-justify-center"
    >
      <img
        src="assets/elipsis/orange.svg"
        alt=""
        class="tw-absolute tw-right-[0px] tw-top-[-5px] lg:tw-top-[-10px] lg:tw-right-[10px] tw-opacity-35 tw-blur-md"
      />
      <img
        src="assets/elipsis/blue.svg"
        alt=""
        class="tw-absolute tw-top-[-5px] tw-right-[0px] lg:tw-top-[-10px] lg:right-[10px] tw-opacity-35 tw-blur-md"
      />
    </div>
  </div>

  <!-- Texto inferior -->
  <div class="tw-flex tw-items-center tw-mt-0 tw-justify-center">
    <h4
      class="tw-text-lg tw-text-center md:tw-text-base lg:tw-text-xl xl:tw-text-2xl 2xl:tw-text-3xl tw-font-montserrat tw-font-bold tw-text-white"
    >
    Mi internet es Onelink
    </h4>
  </div>
</div>
